var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3de89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85920c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9179",
    "data-name": "Group 9179",
    transform: "translate(-3531 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3531 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_447",
    "data-name": "Ellipse 447",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3534 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9174",
    "data-name": "Group 9174",
    transform: "translate(3551.352 10391.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8891",
    "data-name": "Path 8891",
    d: "M1292.143,22.487a5.543,5.543,0,1,1-5.543-5.543,5.543,5.543,0,0,1,5.543,5.543",
    transform: "translate(-1281.058 -16.944)",
    fill: "#28430d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8892",
    "data-name": "Path 8892",
    d: "M1407.234,22.487a5.543,5.543,0,1,0,5.543-5.543,5.543,5.543,0,0,0-5.543,5.543",
    transform: "translate(-1384.082 -16.944)",
    fill: "#28430d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8893",
    "data-name": "Path 8893",
    d: "M1324.947,125.991a13.312,13.312,0,0,1-10.864-5.822,1.566,1.566,0,0,1,2.653-1.666,10.138,10.138,0,0,0,8.211,4.355,10.5,10.5,0,0,0,8.224-4.376,1.566,1.566,0,1,1,2.623,1.712,13.623,13.623,0,0,1-10.847,5.8",
    transform: "translate(-1307.829 -99.272)",
    fill: "#28430d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating4);
export default __webpack_public_path__ + "static/media/rating_4.2d80dfdbc4b3dba6484c2f4271584223.svg";
export { ForwardRef as ReactComponent };